import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "32_vector-map-legend.svg",
  "use": "32_vector-map-legend.svg-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"32_vector-map-legend.svg\"><g id=\"32_vector-map-legend.svg_c\"><g id=\"32_vector-map-legend.svg_d\"><rect width=\"32\" height=\"32\" style=\"fill:none;\" /><rect x=\"4.5\" y=\"4.5\" width=\"24\" height=\"24\" rx=\"1\" ry=\"1\" style=\"fill:#eee; stroke:#3a3a38; stroke-miterlimit:50;\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol